"use client";

import useCollectionCount from "../../lib/firebase/count";

export default function CountCard({ path, name, icon }) {
  const { data, isLoading, error } = useCollectionCount({ path: path });

  if (isLoading) {
    return <h2>Loading ...</h2>;
  }
  if (error) {
    return <p>{error}</p>;
  }

  return (
    // <div className="d-flex gap-2 bg-light p-2 rounded">
    //     {icon}
    //     <div>
    //         <h1 className="fw-bold">{name}</h1>
    //         <h2 className="text-xl fw-bold">{data}</h2>
    //     </div>
    // </div>
    <div className="d-flex flex-row justify-content-start bg-light p-2 rounded">
      <div style={{ width: "10%" }}>{icon}</div>
      <div
        className="d-flex flex-column align-items-center"
        style={{ width: "90%" }}
      >
        <h3 className="">{name}</h3>
        <h4 className="text-xl ">{data}</h4>
      </div>
    </div>
  );
}
